import Vue from 'vue';
import Vuex from 'vuex';
import http from './js/http';
import store from './store/index';
import { syncTextSizeFromServer } from './js/textSize';

Vue.use(Vuex);

const modules = store;

const vueStore = new Vuex.Store({
    modules,
    strict: process.env.NODE_ENV !== 'production',
});

let isVuexBooted = false;

export { isVuexBooted };

let bootPromise = null;

export const bootVuex = () => {
    if (isVuexBooted) {
        return Promise.resolve();
    }

    // Параллельные навигации во время загрузки не должны дублировать запрос и BOOT-диспатчи
    if (bootPromise) {
        return bootPromise;
    }

    // Размер текста запрашивается параллельно со справочниками: пока идёт загрузка, на экране
    // только спиннер, и значение с сервера успевает примениться до появления интерфейса.
    // Ошибку syncTextSizeFromServer гасит сама — загрузку приложения она не держит.
    bootPromise = Promise.all([http.get('source-data'), syncTextSizeFromServer()]).then(([response]) => {
        const app = response.data.app;
        app.securityGroups.forEach((securityGroup) => {
            securityGroup.accounts.sort((left, right) => {
                return left.displayName.localeCompare(right.displayName);
            });
        });
        const promises = [];

        Object.keys(modules).forEach((module) => {
            if (modules[module].actions && modules[module].actions.BOOT) {
                promises.push(vueStore.dispatch(`${module}/BOOT`, app));
            }
        });

        return Promise.all(promises).then(() => {
            isVuexBooted = true;
            Vue.bus.emit('Vuex::Booted');
        });
    });

    bootPromise = bootPromise.catch((error) => {
        bootPromise = null;

        throw error;
    });

    return bootPromise;
};

export default vueStore;
